import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { CartService } from 'src/app/service/cart.service';
import { MenuService } from 'src/app/service/menu.service';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-cart-popup',
  templateUrl: './cart-popup.component.html',
  styleUrls: ['./cart-popup.component.css']
})
export class CartPopupComponent implements OnInit {

  isLoading: boolean = true;
  cartCount: number = 0;
  storeID: number = 0;
  storeName: string = '';

  constructor(
    private menuService: MenuService,
    private userService: UserService,
    private cartService: CartService,
    private router: Router,
    public dialogRef: MatDialogRef<CartPopupComponent>
  ) { }

  ngOnInit(): void {

    this.cartService.getCartV2().pipe(take(1)).subscribe(() => {
      this.cartCount = this.cartService.cartQty();
      const storeData = this.cartService.cartStoreData();
      this.storeID = storeData[0].store_id;
      this.storeName = storeData[0].store_name;
      this.isLoading = false;
      if (this.cartCount === 0) {
        this.dialogRef.close();
      }

    });
  }

  goToCart(): void {
    this.getCartStore();
    this.dialogRef.close('cart');
    this.router.navigate(['/checkout']);
  }

  clearCart(): void {
    this.cartService.clearCartV2().pipe(take(1)).subscribe(() => {
      this.dialogRef.close('cleared');
    });
  }

  getCartStore() {
    this.userService.getUserLocationPayload().then((postData) => {
      this.menuService.getStore(postData, '1').subscribe((response) => {
        if (!response.success) {
          return;
        }
        this.menuService.setStore(response.data);
        let storeList = response.data;
        const exists = storeList.find(item => item.id == this.storeID);

        if (exists) {
          this.userService.setSelectedStore(exists);
        }

      });
    });
  }
}